import React, { Component } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import Validator from 'validatorjs';

import { FormControl } from '../../../../../facturotopia';
import NominaCatalogoManager from '../../../../catalogs/managers/NominaCatalogoManager';

class NominaPercepcionHorasExtraForm extends Component {
  state = {
    data: {},
  };

  get rules() {
    return {
      TipoHoras: ['required', 'string', 'in:01,02,03'],
      Dias: ['required', 'integer', 'min:1'],
      HorasExtra: ['required', 'integer', 'min:1'],
      ImportePagado: ['required', 'decimal:2', 'min:0.00', 'regex:/^[0-9]{1,18}(.[0-9]{1,2})?$/'],
    };
  }

  componentDidMount() {
    this.fillCatalogs();
  }

  async componentDidUpdate() {
    const { data } = this.props;

    if (!!data) {
      const validator = this.validate({ ...data });

      this.setState({
        data: { ...data },
        isValid: validator.passes(),
      });
    }
  }

  fillCatalogs = async () => {
    if (!this.state.catalogos) {
      const values = await NominaCatalogoManager.get('c_nom_tipo_horas');

      if (!!values) {
        let catalogos = {};

        const sorted = values.map((item) => {
          return {
            label: item.descripcion,
            value: item.tipo,
          };
        });

        catalogos.tipoHoras = [
          {
            label: 'Selecciona',
            value: '',
          },
        ].concat(sorted);

        this.setState({
          catalogos,
        });
      }
    }
  };

  validate = (data) => {
    const validator = new Validator(data, this.rules);

    validator.check();

    return validator;
  };

  handleOnChange = (values) => {
    const data = {
      ...this.state.data,
      ...values,
    };

    const validator = this.validate(data);

    this.setState({
      data,
      validator,
      isValid: validator.passes(),
    });
  };

  handleOnAdd = () => {
    this.props.onAdd(this.state.data);

    this.setState({
      data: {},
      isValid: false,
    });
  };

  render() {
    const rules = this.rules;
    const { isValid = false, data = {}, catalogos = {} } = this.state;

    return (
      <>
        <Row>
          <Col
            sm
            md={4}
          >
            <FormControl
              type="select"
              label="Tipo Horas"
              name="TipoHoras"
              placeholder=""
              help=""
              options={catalogos.tipoHoras}
              rules={rules.TipoHoras}
              value={data.TipoHoras}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="number"
              label="Dias"
              name="Dias"
              placeholder=""
              help=""
              min="1"
              rules={rules.Dias}
              value={data.Dias}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="number"
              label="Horas Extra"
              name="HorasExtra"
              placeholder=""
              help=""
              min="1"
              rules={rules.HorasExtra}
              value={data.HorasExtra}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="number"
              label="Importe Pagado"
              name="ImportePagado"
              placeholder=""
              help=""
              min="0"
              rules={rules.ImportePagado}
              value={data.ImportePagado}
              onChange={this.handleOnChange}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <p className="text-muted">
              Puedes agregar varias horas extra usando el botón "Agregar hora extra", las horas extra se mostrarán en la
              tabla de horas extra.
            </p>
          </Col>
        </Row>

        <Row className="pb-2">
          <Col className="text-right">
            <Button
              variant="secondary"
              disabled={!isValid}
              onClick={this.handleOnAdd}
            >
              Agregar hora extra
            </Button>
          </Col>
        </Row>
      </>
    );
  }
}

export default NominaPercepcionHorasExtraForm;
